exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "textarea.ant-input {\n  min-height: 75px !important;\n  max-width: 100%;\n  vertical-align: bottom;\n  -webkit-transition: all .3s, height 0s;\n  -o-transition: all .3s, height 0s;\n  transition: all .3s, height 0s;\n}\n* {\n  font-family: Arial, Helvetica, sans-serif;\n}\n.report-textarea textarea {\n  min-height: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/routes/WorkReport/style.css
// module id = 1655
// module chunks = 0